import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, vModelSelect as _vModelSelect, withDirectives as _withDirectives, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, unref as _unref, withCtx as _withCtx, createVNode as _createVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "row" }
const _hoisted_2 = { class: "col" }
const _hoisted_3 = { class: "d-flex mb-3" }
const _hoisted_4 = ["value"]
const _hoisted_5 = { class: "block" }
const _hoisted_6 = { class: "row mb-2" }
const _hoisted_7 = {
  key: 0,
  class: "col"
}
const _hoisted_8 = {
  key: 1,
  class: "col"
}
const _hoisted_9 = {
  key: 0,
  class: "row"
}
const _hoisted_10 = { class: "col" }
const _hoisted_11 = { class: "text-danger fw-bold" }
const _hoisted_12 = { class: "col" }
const _hoisted_13 = { class: "text-warning fw-bold" }
const _hoisted_14 = { class: "col text-end" }
const _hoisted_15 = ["href"]
const _hoisted_16 = {
  key: 0,
  class: "block"
}
const _hoisted_17 = { class: "row mb-3" }
const _hoisted_18 = { class: "col-auto" }
const _hoisted_19 = ["value"]
const _hoisted_20 = { class: "col text-end" }
const _hoisted_21 = ["href"]
const _hoisted_22 = {
  key: 1,
  class: "block"
}

import {computed, onBeforeMount, onMounted, reactive, ref, watch} from "vue";
import {BCard} from "./../Misc";
import {UploadType} from "@/types";
import {useContactsStore} from "@/stores/contactsStore";
import {useCommunityPolicingStore} from "@/stores/communityPolicingStore";
import {useNibrsStore} from "@/stores/nibrsStore";
import {useSummaryStore} from "@/stores/summaryStore";
import {useUofStore} from "@/stores/uofStore";
import {usePoliceEmployeeStore} from "@/stores/policeEmployeeStore";
import {BTableColumn, BTableOptions} from "../BTable/BTable.types";
import BTable from "../BTable/BTable.vue";
import {useOriStore} from "@/stores/oriStore";
import hasPermission from "@/composable/permissionHelper";
import {formatPercent} from "@/utils";

export default /*@__PURE__*/_defineComponent({
  __name: 'AgencySubmission',
  props: {
    ori: {
        type: String,
        default: null,
    },
},
  setup(__props) {

const props = __props;

const selectedDataset = ref();
const selectedPeriod = ref(0);
const datasets = ref<any[]>();
const oriStore = useOriStore();

function filterDatasets() {
    var result: any[] = [];
    if (oriStore.ori != null) {
        oriStore.ori.data_collection_status.forEach((element) => {            

            if (element.agency_enabled) {
                result = result.concat(datasetsDefinition.filter((x) => x.code == element.name));
            }
        });
    }

    datasets.value = result.filter((x) => hasPermission(x.permission));
}

const title = computed(() => {
    return selectedDatasetDefinition.value!.name;
});

const selectedDatasetDefinition = computed(() =>
    datasetsDefinition.findLast((it) => it.value == selectedDataset.value)
);

const vendor = computed(() => {
    if (!oriStore.ori || !selectedDatasetDefinition.value) {
        return null;
    }
    return oriStore.ori.data_collection_status.findLast((x) => x.label == selectedDatasetDefinition.value!.name);
});
const statisticsTableOptions: BTableOptions = {
    itemsPerPage: 1,
    page: 1,
    sortBy: [],
    totalItemCount: 0,
    pagingMode: "noTotal",
};
const lastSubmissionTableOptions: BTableOptions = {
    itemsPerPage: 1,
    page: 1,
    sortBy: [],
    totalItemCount: 0,
    pagingMode: "noTotal",
};

const statisticsColumns = reactive<BTableColumn[]>([
    {
        key: "reports_processed",
        text: "Total Records",
        sortable: false,
        columnClass: ["align-top"],
        value: (item) => item.reports_processed,
    },
    {
        key: "reports_rejected",
        text: "Rejected",
        sortable: false,
        columnClass: ["align-top"],
        value: (item) => item.reports_rejected,
    },
    {
        key: "error_rate",
        text: "Error Rate",
        sortable: false,
        columnClass: ["align-top"],
        class: (item) => ["text-nowrap"],
        value: (item) => item.error_rate,
    },
]);

const lastSubmissionColumns = reactive<BTableColumn[]>([
    {
        key: "upload_date",
        text: "Date/Time",
        sortable: false,
        columnClass: ["align-top"],
        value: (item) => item.upload_date,
    },
    {
        key: "file_name",
        text: "Filename",
        sortable: false,
        columnClass: ["align-top"],
        value: (item) => item.file_name,
    },
    {
        key: "uploaded_by",
        text: "Uploaded By",
        sortable: false,
        columnClass: ["align-top"],
        class: (item) => ["text-nowrap"],
        value: (item) => item.uploaded_by,
    },
    {
        key: "total_records",
        text: "Total Records",
        sortable: false,
        columnClass: ["align-top"],
        class: (item) => ["text-nowrap"],
        value: (item) => item.total_records,
    },
    {
        key: "rejected",
        text: "Rejected",
        sortable: false,
        columnClass: ["align-top"],
        class: (item) => ["text-nowrap"],
        value: (item) => item.rejected,
    },
    {
        key: "error_rate",
        text: "Error Rate",
        sortable: false,
        columnClass: ["align-top"],
        class: (item) => ["text-nowrap"],
        value: (item) => item.error_rate,
    },
]);

const store = computed(() => {
    var uploadType: UploadType = selectedDataset.value;

    switch (uploadType) {
        case UploadType.contacts:
            return useContactsStore();

        case UploadType.communityPolicing:
            return useCommunityPolicingStore();

        case UploadType.nibrs:
            return useNibrsStore();

        case UploadType.summary:
            return useSummaryStore();

        case UploadType.useOfForce:
            return useUofStore();

        case UploadType.policeEmployee:
            return usePoliceEmployeeStore();
    }
});

watch(props, async () => {
    if (!props.ori) {
        return;
    }
    await oriStore.getOri(props.ori);

    filterDatasets();
    if (datasets.value && datasets.value.length) {
        selectedDataset.value = datasets.value[0].value;
    }
    if (store.value) {
        await store.value.loadErrorsSummary(props.ori);
        await store.value.loadStatisticsSummary(selectedPeriod.value, props.ori);
        await store.value.loadLastSubmission(props.ori);
    }
});
watch(selectedDataset, async () => {
    if (!props.ori) {
        return;
    }
    if (store.value) {
        await store.value.loadErrorsSummary(props.ori);
        await store.value.loadStatisticsSummary(selectedPeriod.value, props.ori);
        await store.value.loadLastSubmission(props.ori);
    }
});
watch(selectedPeriod, async () => {
    if (!props.ori) {
        return;
    }
    if (store.value) {
        await store.value.loadStatisticsSummary(selectedPeriod.value, props.ori);
        await store.value.loadLastSubmission(props.ori);
    }
});

const periods = [
    {name: "Today", value: 0},
    {name: "This Week", value: 1},
    {name: "This Month", value: 2},
    {name: "This Year", value: 3},
];

const datasetsDefinition = [
    {name: "NIBRS", value: 0, permission: "dataupload", code: "NIBRS"},
    {name: "Use of Force", value: 2, permission: "useOfForceDataUpload", code: "UOF"},
    {name: "Community Policing", value: 6, permission: "CommunityPolicingDataUpload", code: "VACP"},
    {name: "Contacts", value: 5, permission: "ContactDataUpload", code: "CONTACTS"},
];

return (_ctx: any,_cache: any) => {
  return (datasets.value?.length)
    ? (_openBlock(), _createBlock(_unref(BCard), {
        key: 0,
        header: "Data Collection Overview"
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, [
            _createElementVNode("div", _hoisted_2, [
              _createElementVNode("form", _hoisted_3, [
                _cache[2] || (_cache[2] = _createElementVNode("label", {
                  for: "dataset",
                  class: "align-self-center me-3"
                }, [
                  _createElementVNode("h3", { class: "mb-0" }, "Data Collection")
                ], -1)),
                _createElementVNode("div", null, [
                  _withDirectives(_createElementVNode("select", {
                    class: "form-select",
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((selectedDataset).value = $event)),
                    id: "dataset"
                  }, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(datasets.value, (dataset) => {
                      return (_openBlock(), _createElementBlock("option", {
                        value: dataset.value
                      }, _toDisplayString(dataset.name), 9, _hoisted_4))
                    }), 256))
                  ], 512), [
                    [_vModelSelect, selectedDataset.value]
                  ])
                ])
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              (vendor.value)
                ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                    _cache[3] || (_cache[3] = _createElementVNode("span", { class: "h5" }, "Start Date: ", -1)),
                    _createTextVNode(" " + _toDisplayString(vendor.value.agency_start_date), 1)
                  ]))
                : _createCommentVNode("", true),
              (vendor.value)
                ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                    _cache[4] || (_cache[4] = _createElementVNode("span", { class: "h5" }, "Vendor: ", -1)),
                    _createTextVNode(" " + _toDisplayString(vendor.value.vendor_name), 1)
                  ]))
                : _createCommentVNode("", true),
              _cache[5] || (_cache[5] = _createElementVNode("div", { class: "col" }, null, -1))
            ]),
            (store.value?.datasetSummary)
              ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                  _createElementVNode("div", _hoisted_10, [
                    _cache[6] || (_cache[6] = _createElementVNode("span", { class: "h5" }, "Outstanding Errors: ", -1)),
                    _createElementVNode("span", _hoisted_11, _toDisplayString(store.value.datasetSummary.error_count) + " error" + _toDisplayString(store.value.datasetSummary.error_count !== 1 ? 's' : ''), 1)
                  ]),
                  _createElementVNode("div", _hoisted_12, [
                    _cache[7] || (_cache[7] = _createElementVNode("span", { class: "h5" }, "Outstanding Warnings: ", -1)),
                    _createElementVNode("span", _hoisted_13, _toDisplayString(store.value.datasetSummary.warning_count) + " warning" + _toDisplayString(store.value.datasetSummary.warning_count !== 1 ? 's' : ''), 1)
                  ]),
                  _createElementVNode("div", _hoisted_14, [
                    _createElementVNode("a", {
                      href: `ErrorsAndWarnings.aspx?source=${selectedDataset.value}`
                    }, "View Outstanding Errors and Warnings", 8, _hoisted_15)
                  ])
                ]))
              : _createCommentVNode("", true)
          ]),
          _cache[9] || (_cache[9] = _createElementVNode("h3", { class: "mt-4" }, "Last Submission", -1)),
          (store.value?.datasetLastSubmissions)
            ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                _createVNode(BTable, {
                  items: store.value.datasetLastSubmissions,
                  columns: lastSubmissionColumns,
                  caption: `Last ${title.value} Submission`,
                  "aria-label": `Last ${title.value} Submission`,
                  value: lastSubmissionTableOptions
                }, {
                  "cell.error_rate": _withCtx(({item, column}) => [
                    _createTextVNode(_toDisplayString(_unref(formatPercent)(item.error_rate)), 1)
                  ]),
                  _: 1
                }, 8, ["items", "columns", "caption", "aria-label"])
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_17, [
            _cache[8] || (_cache[8] = _createElementVNode("div", { class: "col-auto d-flex mb-0" }, [
              _createElementVNode("label", {
                for: "submissionOverviewPeriod",
                class: "align-self-center mb-0"
              }, [
                _createElementVNode("h3", { class: "mb-0" }, "Submission Overview for")
              ])
            ], -1)),
            _createElementVNode("div", _hoisted_18, [
              _withDirectives(_createElementVNode("select", {
                id: "submissionOverviewPeriod",
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((selectedPeriod).value = $event)),
                class: "form-select"
              }, [
                (_openBlock(), _createElementBlock(_Fragment, null, _renderList(periods, (item) => {
                  return _createElementVNode("option", {
                    value: item.value
                  }, _toDisplayString(item.name), 9, _hoisted_19)
                }), 64))
              ], 512), [
                [_vModelSelect, selectedPeriod.value]
              ])
            ]),
            _createElementVNode("div", _hoisted_20, [
              _createElementVNode("a", {
                href: `dataupload.aspx?source=${selectedDataset.value}`
              }, "View Upload History", 8, _hoisted_21)
            ])
          ]),
          (store.value?.datasetStatisticsSummary)
            ? (_openBlock(), _createElementBlock("div", _hoisted_22, [
                _createVNode(BTable, {
                  items: store.value.datasetStatisticsSummary,
                  columns: statisticsColumns,
                  caption: `${title.value} Incidents Uploaded`,
                  "aria-label": `${title.value} Incidents Uploaded`,
                  value: statisticsTableOptions
                }, {
                  "cell.error_rate": _withCtx(({item, column}) => [
                    _createTextVNode(_toDisplayString(_unref(formatPercent)(item.error_rate)), 1)
                  ]),
                  _: 1
                }, 8, ["items", "columns", "caption", "aria-label"])
              ]))
            : _createCommentVNode("", true)
        ]),
        _: 1
      }))
    : _createCommentVNode("", true)
}
}

})